// Mock data for David Provenzani's portfolio

export const profileData = {
  name: "David Provenzani",
  title: "Senior Commercial Leader | MENA & GCC Specialist",
  tagline: "25+ Years of Executive Leadership in Renewable Energy & Infrastructure",
  email: "info@architaly.green",
  phone: "+971 55 9472027",
  location: "Ras Al-Khaimah, UAE",
  linkedin: "https://www.linkedin.com/in/davidprovenzani",
  photo: "https://customer-assets.emergentagent.com/job_bbc8d335-b081-40da-a49d-ce648bef695f/artifacts/h5no1psm_Pic%20David%20HD%20Colour.png",
  summary: "A seasoned Senior Director with over 25 years of executive leadership experience, specializing in renewable energy, education, and sustainability. Recognized as an entrepreneurial thought leader adept at leveraging extensive leadership experience to drive strategic initiatives and transform innovative ideas into tangible results."
};

export const experiences = [
  {
    id: 1,
    company: "Terracore Engineering Services LLC",
    location: "Dubai, UAE",
    role: "Strategy Head, Partner",
    period: "February 2025 - February 2026",
    description: "Appointed as Strategy Advisor to design and oversee the global development strategy, focusing on identifying suitable verticals and prospective initiatives to expand the company's commercial presence in the UAE and GCC market.",
    highlights: [
      "Strategic development and planning",
      "UAE and GCC market expansion",
      "Commercial presence optimization",
      "Business vertical identification"
    ]
  },
  {
    id: 2,
    company: "Yellow Door Energy DMCC",
    location: "Dubai, UAE",
    role: "Country Director, UAE & Oman",
    period: "February 2022 - October 2024",
    description: "Oversaw and advised operations and sales in UAE and Oman markets, focusing on large corporate and public clients with financed green energy/energy efficiency solutions.",
    highlights: [
      "Led team of five professionals",
      "Expanded product portfolio",
      "Smart Micro Grid Solutions implementation",
      "Strategic partnerships with public authorities",
      "B2G/B2B deal execution"
    ]
  },
  {
    id: 3,
    company: "Jet Capsule SRL",
    location: "Italy",
    role: "Founding Partner",
    period: "March 2019 - Present",
    description: "Drove growth for a sustainable water mobility company. Established innovative corporate vision and global marketing strategy.",
    highlights: [
      "Sustainable water mobility innovation",
      "Global marketing strategy development",
      "Financial planning and analysis",
      "Strategic partnerships and client acquisition"
    ]
  },
  {
    id: 4,
    company: "Architaly Green Energy DMCC",
    location: "Dubai, UAE",
    role: "Founder & Managing Director",
    period: "January 2013 - January 2022",
    description: "Founded a consulting firm specializing in sustainable energy and green mobility advisory. Launched initiatives like 'DubaiSolar.Org' and the 'Dubai Solar Schools Programme'.",
    highlights: [
      "Founded Dubai Solar Schools Programme",
      "Sustainability consultant for UAE Federal Government",
      "Partnership with Sheikh Mohammed Centre for Cultural Understanding",
      "DEWA Media Partner Status",
      "Advanced technology solutions development"
    ]
  },
  {
    id: 5,
    company: "Architaly SRL",
    location: "Bologna, Italy",
    role: "Co-Founder & Managing Director",
    period: "January 1997 - January 2012",
    description: "Co-founded a consulting and design firm with a focus on sustainability. Led the solar energy consulting and permitting division, originating over 500 MWp of solar permitting approvals.",
    highlights: [
      "500+ MWp solar permitting approvals",
      "Municipal and regulatory compliance",
      "EPC and financial institution coordination",
      "Recognized solar consultant in Italy",
      "Large-scale B2G deal execution"
    ]
  }
];

export const education = [
  {
    id: 1,
    institution: "Amity University Dubai",
    location: "Dubai, United Arab Emirates",
    degree: "Honorary Professorship in Sustainable Planning",
    year: "2017",
    description: "Awarded following the establishment of the first solar plant in Dubai's academic sector.",
    type: "honorary"
  },
  {
    id: 2,
    institution: "Politecnico University of Milan",
    location: "Milan, Italy",
    degree: "Master in Sustainable Architecture",
    year: "1995",
    description: "Advanced studies in sustainable architectural design and planning.",
    type: "master"
  },
  {
    id: 3,
    institution: "University of Florence",
    location: "Florence, Italy",
    degree: "B.Sc. Cum Laude in Senior Architecture",
    year: "1992",
    description: "Graduated with honors in architectural studies.",
    type: "bachelor"
  },
  {
    id: 4,
    institution: "Collegio San Luigi of Bologna",
    location: "Bologna, Italy",
    degree: "High School Diploma",
    year: "1987",
    description: "Secondary education completion.",
    type: "secondary"
  }
];

export const awards = [
  {
    id: 1,
    title: "Honorary Professorship",
    issuer: "Amity University Dubai",
    year: "2017",
    description: "Awarded following the establishment of the first solar plant in Dubai's academic sector."
  },
  {
    id: 2,
    title: "Young Global Leader",
    issuer: "Leaders Middle East & RAK Tourism Authority",
    year: "2017",
    description: "Recognized for outstanding leadership and innovation in the MENA region."
  }
];

export const mentions = [
  { id: 1, name: "Gulf News", type: "media" },
  { id: 2, name: "The National", type: "media" },
  { id: 3, name: "Khaleej Times", type: "media" },
  { id: 4, name: "MESIA", type: "media" },
  { id: 5, name: "Arabian Business", type: "media" },
  { id: 6, name: "Utilities Middle East", type: "media" },
  { id: 7, name: "Hi Dubai", type: "media" },
  { id: 8, name: "Sharjah Investment Forum", type: "event" },
  { id: 9, name: "Solar Magazine", type: "media" },
  { id: 10, name: "ESI Africa", type: "media" }
];

export const initiatives = [
  {
    id: 1,
    title: "Dubai Solar Schools Programme",
    description: "Created comprehensive solar lease and solar lab initiative for schools in Dubai.",
    year: "2016 - 2020"
  },
  {
    id: 2,
    title: "Schools' Green Team Programme",
    description: "Energy efficiency initiative for educational institutions in Dubai.",
    year: "2018 - 2020"
  },
  {
    id: 3,
    title: "Amity University Dubai Solar Lab",
    description: "Co-founder and board member of the university's solar laboratory.",
    year: "2017"
  },
  {
    id: 4,
    title: "SMCCU Dubai Solar Schools Award",
    description: "Annual award in partnership with Sheikh Mohammed Centre for Cultural Understanding.",
    year: "2017 - 2020"
  }
];

export const certifications = [
  {
    id: 1,
    title: "Member of the Board of Alumni",
    organization: "University of Florence, Italy",
    period: "1998-2003"
  },
  {
    id: 2,
    title: "Honorary Professor",
    organization: "Amity University Dubai - School of Architecture & Planning",
    period: "2017"
  },
  {
    id: 3,
    title: "Leadership Team Member",
    organization: "Singularity University Abu Dhabi Chapter",
    period: "2018"
  },
  {
    id: 4,
    title: "University Associate",
    organization: "Curtin University Dubai",
    period: "2019"
  },
  {
    id: 5,
    title: "Member of SAC (Scientific Advisors Committee)",
    organization: "National Qualification Authority (NQA) - UAE Federal Government",
    period: "2019"
  }
];

export const skills = [
  "Executive Leadership",
  "Renewable Energy",
  "Business Development",
  "Strategic Planning",
  "B2G/B2B Sales",
  "Fundraising",
  "Team Building",
  "Public Speaking",
  "Sustainability Consulting",
  "Market Analysis",
  "Regulatory Compliance",
  "Partnership Development"
];

export const stats = [
  { label: "Years of Experience", value: "25+" },
  { label: "Keynote Speeches", value: "100+" },
  { label: "Solar Permitting", value: "500+ MWp" },
  { label: "Years in MENA", value: "13+" }
];

// Mock publications data
export const mockPublications = [
  {
    id: 1,
    title: "David Provenzani CV - March 2026",
    fileName: "David_Provenzani_CV.pdf",
    uploadDate: "2026-03-15",
    fileSize: "2.5 MB",
    preview: "https://customer-assets.emergentagent.com/job_bbc8d335-b081-40da-a49d-ce648bef695f/artifacts/27p0bjpd_David%20Provenzani%20CV%20-%20As%20of%20March%202026.pdf"
  },
  {
    id: 2,
    title: "Commercial Leadership Profile",
    fileName: "Commercial_Leadership_Profile.pdf",
    uploadDate: "2026-03-10",
    fileSize: "1.8 MB",
    preview: "https://customer-assets.emergentagent.com/job_bbc8d335-b081-40da-a49d-ce648bef695f/artifacts/nyc6bow9_Commercial%20Leadership%20Profile%20-%20David%20Provenzani.pdf"
  }
];
